module.exports = "<svg width=\"9\" height=\"16\" viewBox=\"0 0 9 16\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#FEF899\" d=\"M5.922 1L1 8.629h3.61L2.421 15 8 7.12H4.061z\"></path><path d=\"M5.922 1L1 8.629h3.61L2.421 15 8 7.12H4.061L5.921 1zm-.85 5.37H8a.75.75 0 0 1 .612 1.183l-5.578 7.88c-.5.708-1.603.143-1.321-.677L3.559 9.38H1a.75.75 0 0 1-.63-1.157L5.292.593c.471-.73 1.6-.207 1.347.625L5.073 6.37z\" fill=\"#E8AD0E\" fill-rule=\"nonzero\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeSVGTagAttrs=false&removeTags=false!./src/images/svg/bolt.svg
// module id = b93K
// module chunks = 89